(function () {
  function init(root) {
    const track = root.querySelector(".fp-carousel__track");
    const prev = root.querySelector(".fp-carousel__btn--prev");
    const next = root.querySelector(".fp-carousel__btn--next");
    if (!track || !prev || !next) return;

    function step() {
      const slide = track.querySelector(".fp-carousel__slide");
      if (!slide) return track.clientWidth;
      const slideW = slide.getBoundingClientRect().width;
      const gap = parseFloat(getComputedStyle(track).gap || "0");
      return slideW + (isNaN(gap) ? 0 : gap);
    }

    prev.addEventListener("click", () => track.scrollBy({ left: -step(), behavior: "smooth" }));
    next.addEventListener("click", () => track.scrollBy({ left: step(), behavior: "smooth" }));
  }

  document.addEventListener("DOMContentLoaded", function () {
    document.querySelectorAll("[data-fp-carousel]").forEach(init);
  });
})();
